import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  Icon,
  VStack,
  useColorModeValue,
  Button,
  Image,
} from '@chakra-ui/react';
import { FaChartLine, FaHandshake, FaLightbulb, FaGraduationCap, FaUsers, FaMoneyBillWave } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';

const Feature = ({ title, text, icon }) => {
  return (
    <VStack
      p={8}
      bg={useColorModeValue('white', 'gray.800')}
      rounded="xl"
      shadow="lg"
      textAlign="center"
      spacing={4}
      _hover={{
        transform: 'translateY(-5px)',
        transition: 'all 0.2s ease-in-out',
        shadow: 'xl',
      }}
    >
      <Icon as={icon} w={10} h={10} color="blue.500" />
      <Heading size="md">{title}</Heading>
      <Text color={useColorModeValue('gray.600', 'gray.400')}>{text}</Text>
    </VStack>
  );
};

const WhyJoinUs = () => {
  const benefits = [
    {
      title: 'High Earning Potential',
      text: 'Earn competitive commissions on every successful investment. Our commission structure rewards your hard work and dedication.',
      icon: FaMoneyBillWave,
    },
    {
      title: 'Professional Development',
      text: 'Access comprehensive training programs and continuous learning opportunities to enhance your financial expertise.',
      icon: FaGraduationCap,
    },
    {
      title: 'Market Insights',
      text: 'Stay ahead with our cutting-edge market analysis tools and regular industry updates from expert analysts.',
      icon: FaChartLine,
    },
    {
      title: 'Strong Support System',
      text: 'Join a network of successful professionals. Our experienced team is always ready to support your growth.',
      icon: FaUsers,
    },
    {
      title: 'Innovative Solutions',
      text: 'Access to state-of-the-art technology and tools to manage your clients and grow your business efficiently.',
      icon: FaLightbulb,
    },
    {
      title: 'Client Trust',
      text: 'Partner with a respected brand that helps you build lasting relationships with clients through trust and reliability.',
      icon: FaHandshake,
    },
  ];

  return (
    <Box py={20} bg={useColorModeValue('gray.50', 'gray.900')}>
      <Container maxW="7xl">
        <VStack spacing={12}>
          {/* Hero Section */}
          <VStack spacing={4} textAlign="center">
            <Heading
              as="h1"
              size="2xl"
              bgGradient="linear(to-r, blue.400, blue.600)"
              backgroundClip="text"
            >
              Why Join Our Network?
            </Heading>
            <Text
              fontSize="xl"
              color={useColorModeValue('gray.600', 'gray.400')}
              maxW="2xl"
            >
              Become part of a growing network of successful mutual fund distributors.
              We provide the tools, support, and environment you need to thrive.
            </Text>
          </VStack>

          {/* Benefits Grid */}
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10} width="full">
            {benefits.map((benefit, index) => (
              <Feature key={index} {...benefit} />
            ))}
          </SimpleGrid>

          {/* Call to Action */}
          <Box textAlign="center" py={10}>
            <VStack spacing={4}>
              <Heading size="lg">Ready to Start Your Journey?</Heading>
              <Text color={useColorModeValue('gray.600', 'gray.400')} maxW="2xl">
                Join our network today and take the first step towards a rewarding career
                in mutual fund distribution.
              </Text>
              <Button
                as={RouterLink}
                to="/register"
                size="lg"
                colorScheme="blue"
                px={8}
                _hover={{
                  transform: 'translateY(-2px)',
                  boxShadow: 'lg',
                }}
              >
                Join Now
              </Button>
            </VStack>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default WhyJoinUs;
